import React, { useState } from "react";
import { Button } from "@design-system/Button/Button";
import { DateRangeFilterNext } from "@design-system/DateRangeFilter/DateRangeFilterNext";
import type { DateOnlyDateRange } from "@design-system/DateRangeFilter/DateRangeFilterNext.lib";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./SpecializedInputPlayground.module.scss";

const initialDateRange: DateOnlyDateRange = {
    start: "2026-01-01",
    end: "2026-03-31",
};

export const DateRangeFilterPlayground = () => {
    const [dateRange, setDateRange] =
        useState<DateOnlyDateRange>(initialDateRange);
    const [isSelectionRequired, setIsSelectionRequired] = useState(false);
    const [isAllTime, setIsAllTime] = useState(false);

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Selection</h2>
                        <BooleanControl
                            label="Require a date range"
                            checked={isSelectionRequired}
                            onChange={setIsSelectionRequired}
                        />
                    </section>
                    <section className={styles.fields}>
                        <h2>Try it</h2>
                        <p className={styles.hint}>
                            Open the picker to choose a preset or select a
                            custom start and end month. Changes stay local to
                            this showcase.
                        </p>
                        <Button
                            type="button"
                            variant="primary"
                            size="md"
                            onClick={() => {
                                setDateRange(initialDateRange);
                                setIsAllTime(false);
                            }}
                        >
                            Reset range
                        </Button>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary="Presets + custom range"
                output={JSON.stringify(
                    {
                        props: {
                            dateRange,
                            requireSelection: isSelectionRequired,
                        },
                        onChangeState: {
                            isAllTime,
                        },
                    },
                    null,
                    2,
                )}
            >
                <DateRangeFilterNext
                    dateRange={dateRange}
                    onChange={(nextDateRange, nextIsAllTime) => {
                        setDateRange(nextDateRange);
                        setIsAllTime(nextIsAllTime ?? false);
                    }}
                    requireSelection={isSelectionRequired}
                />
            </ShowcasePreview>
        </SandboxLayout>
    );
};
